import type { CrmEventDTO } from '../../../server/dto/crm-event-dto.ts';
import type { CustomerDTO } from '../../../server/dto/customer-dto.ts';
import type { EventInput } from '../../../server/queries/utils/crm-event-build-input.ts';

/**
 * Converts CRM event details to form input data structure
 */
export function getInputFromCrmEventDetails(
    eventDetails: CrmEventDTO & { customer?: CustomerDTO },
): EventInput {
    return {
        customer_id: eventDetails.customer?.customerId,
        date: eventDetails.date,
        start_time: eventDetails.start_time,
        end_time: eventDetails.end_time,
        address: eventDetails.address,
        description: eventDetails.description,
        title: eventDetails.title ?? '',
        agenda: eventDetails.agendaRich,
        recurrence: eventDetails.recurrence,
        attendees: eventDetails.attendees,
    };
}
